<template>
  <div class="evalua_page-root org_show_evalua-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">{{classInfo.name}}</p>
      </yioks-page-nav>
      <div class="content-wrap">
        <user :class-info="classInfo" :dataPhase="dataPhase"></user>
        <!-- <p class="evalua-tip">请根据中国足协要求，依据实际情况认真填写问卷调查，这样会有助于国家足球体育的不断进步！</p> -->
        <div class="evalua-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="$options._myOpt.vuescrollOpt">
              <div class="scroll-content">
                <div class="evaluat-box" v-for="(item,index) in evaluatRes" :key="index">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对{{item.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :is-edit="false" :star-num.sync="item.starNum"></yioks-rating>
                  <div v-show="item.starNum < 5">
                    <p class="cont-title">存在以下现象</p>
                    <yioks-evaluation
                      class="cont-box"
                      :is-edit="false"
                      :conts-list.sync="item.contsList"
                    ></yioks-evaluation>
                  </div>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      class="textarea"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { correctStatus } from "@/assets/js/apiStatus";
import { getEvaluations } from "@/api/agency/agency";
const HOSTURL = process.env.VUE_APP_URL;
const SPLIT_CHAR = ",";

export default {
  name: "OrgShowEvalua",
  _myOpt: {
    vuescrollOpt: createScrollOpt()
  },
  props: {
    classId: {}
  },
  components: {
    "v-icon": Icon,
    user: () => import("./components/EvaluatUser"),
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-rating": () => import("@/components/Rating/Rating"),
    "yioks-evaluation": () => import("@/components/EvaluaConts/EvaluaConts")
  },
  created() {
    this.evaluatInfo();
  },
  data() {
    return {
      classInfo: {},
      evaluatRes: [],
      dataPhase:{}
    };
  },
  methods: {
    evaluatInfo() {
      getEvaluations({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          const transData = (arr, type = "") =>
            arr.map(({ name, star, other_eva, tag_list }, i) => ({
              id: type + i + 1,
              name: type + name,
              starNum: star,
              suggest: other_eva,
              contsList: tag_list.map(({ is_option, title }, i) => ({
                checked: !!is_option,
                text: title,
                id: i + 1
              }))
            }));
          const { result } = data;
          const { class_info, evaluation_data, teacher_data,dataPhase, teacher_off_data,lecturer_assistant_data,goalkeeper_data,physical_data } = result;
          if (dataPhase){
            this.dataPhase={
              start_date:dataPhase[0].start_date,
              start_date1:dataPhase[1].start_date,
              end_date:dataPhase[0].end_date,
              end_date1:dataPhase[1].end_date,
            }
          }
          this.classInfo = {
            ...class_info,
            moment_picture: class_info.moment_picture
              ? HOSTURL + class_info.moment_picture
              : ""
          };
          this.evaluatRes = [
            ...transData(Array.isArray(evaluation_data) ? evaluation_data:[], "机构"),
            ...transData(Array.isArray(teacher_off_data) ? teacher_off_data:[], "主讲师"),
            ...transData(Array.isArray(teacher_data) ? teacher_data:[], "助理讲师"),
            ...transData(Array.isArray(lecturer_assistant_data) ? lecturer_assistant_data:[], "讲师助理"),
            ...transData(Array.isArray(goalkeeper_data) ? goalkeeper_data:[], ""),
            ...transData(Array.isArray(physical_data) ? physical_data:[], ""),
          ];
        } else {
        }
      });
    },
    goBack() {
      this.$router.push({
        name: "OrgEvaluationList"
      });
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluation'
</style>
